import React, { useState } from "react";
import {
  TextField,
  PrimaryButton,
  Dialog,
  DialogFooter,
  DialogType,
  DefaultButton,
  IconButton,
  mergeStyleSets,
} from "@fluentui/react";
import { GetTinyUrl } from "../Services/JobConfigurationServices";
import { CallSyncEndpoint } from "../Services/JobConfigurationServices";

const classNames = mergeStyleSets({
    inputWithIcon: {
        display: "flex",
        alignItems: "center",
        position: "relative",
    },
    copyIcon: {
        position: "absolute",
        right: 0,
        top: "50%",
        transform: "translateY(-50%)",
        marginRight: 8,
    },
    urlInput: {
        width: "100%",
        paddingRight: "40px",
    },
});

const TniyUrl = () => {
    const [jobId, setJobId] = useState("");
    const [userId, setUserId] = useState("");
    const [dialogVisible, setDialogVisible] = useState(false);
    const [generatedUrl, setGeneratedUrl] = useState("");
    const [loading, setLoading] = useState(false);

    const handleGenerate = async () => {
        if (!jobId.trim() || !userId.trim()) {
        alert("Please enter both Job ID and User ID");
        return;
        }

        setLoading(true);
        const result = await GetTinyUrl(jobId.trim(), userId.trim());
        setLoading(false);

        if (result === "failed") {
        alert("Failed to fetch URL. Please try again.");
        } else {
        setGeneratedUrl(result);
        setDialogVisible(true);
        }
    };

    const handleCopy = async () => {
        try {
        await navigator.clipboard.writeText(generatedUrl);
        alert("URL copied to clipboard!");
        } catch (error) {
        alert("Failed to copy URL.");
        }
    };

    const handleCloseDialog = () => {
        setDialogVisible(false);
        setJobId("");
        setUserId("");
    };

    const handleSync = async () => {
        setLoading(true);
        const result = await CallSyncEndpoint();
        setLoading(false);

        if (result === "success") {
            alert("Sync completed successfully.");
        } else {
            alert("Sync failed. Please try again.");
        }
    };



    return (
        <div style={{ padding: "20px" }}>
            <b>Tiny URL</b>

            <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", paddingTop:"5px" }}>
                <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", paddingRight: "42%"}}>
                    <TextField
                        placeholder="Job ID"
                        value={jobId}
                        onChange={(e, newValue) => setJobId(newValue)}
                        style={{ width: "200px" }}
                    />
                    <TextField
                        placeholder="User ID"
                        value={userId}
                        onChange={(e, newValue) => setUserId(newValue)}
                        style={{ width: "200px" }}
                    />
                    <PrimaryButton
                        text={loading ? "Generating..." : "Generate"}
                        onClick={handleGenerate}
                        disabled={loading}
                    />
                </div>

                    {/* Sync Button */}
                    <PrimaryButton
                        text="Sync"
                        onClick={handleSync}
                        disabled={loading}
                        style={{ height: "32px" }}
                        />
            </div>

            <Dialog
                hidden={!dialogVisible}
                onDismiss={handleCloseDialog}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Generated URL",
                    subText: "Use the URL below:",
                }}
                modalProps={{ isBlocking: true }}
                >
                <div className={classNames.inputWithIcon}>
                    <TextField
                    readOnly
                    value={generatedUrl}
                    className={classNames.urlInput}
                    />
                    <IconButton
                    iconProps={{ iconName: "Copy" }}
                    className={classNames.copyIcon}
                    onClick={handleCopy}
                    title="Copy URL"
                    ariaLabel="Copy URL"
                    />
                </div>

                <DialogFooter>
                    <PrimaryButton onClick={handleCopy} text="Copy" />
                    <DefaultButton onClick={handleCloseDialog} text="Close" />
                </DialogFooter>
                </Dialog>

        </div>
    );
};

export default TniyUrl;
